import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  data: [],
  error: null,
  loading: false,
};

const prePopulatedGroups = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_PRE_POPULATED_GROUPS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GET_PRE_POPULATED_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };

    case actionTypes.GET_PRE_POPULATED_GROUPS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};

export default prePopulatedGroups;
